/* eslint-disable import/prefer-default-export */
import { httpDelete, httpGet, httpPost } from '../httpCalls';
import store from '../../store';
import { reloadVodOutputs } from '../../actions/vodOutputsActions';


export const createVodOutput = (data) => {
  const vodId = store.getState().vods[0].id;
  return httpPost('vodOutputs', { ...data, vodId }).then(() => httpGet(`vod/${vodId}`).then((vod) => {
    const vodOutputs = vod.vodOutputs.map((x) => {
      const element = { ...x };
      element.parent = vod.id;

      return element;
    });
    store.dispatch(reloadVodOutputs(vodOutputs));
    return vodOutputs;
  }));
};
export const removeVodOutput = (data) => {
  return httpDelete(`vodOutputs/${data.id}`);
};
